.gg{border:1px solid #ddd;}